import { render, staticRenderFns } from "./BookingLoader.vue?vue&type=template&id=2fef17ec&"
import script from "./BookingLoader.vue?vue&type=script&lang=js&"
export * from "./BookingLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports